
import { Component, Vue } from 'vue-property-decorator';
import { DefaultDatePickerLangSettings } from '../../utils/constants';
import { RoomSpace } from '../../utils/models';
import { DataService } from '@/service/DataService';
import { getDataServerUrl } from '@/utils/functions';
import LoadingPopup from '../../components/popup/room/LoadingPopup.vue';

@Component({ components: { LoadingPopup } })
export default class LogView extends Vue {
  logDateRange: Date[] = [];
  logExportSpaces: string[] = [];
  datePickerLang = DefaultDatePickerLangSettings;
  isLoading = false;
  defaultValue = new Date(); // mounted で一か月後を指定
  private servUrl = getDataServerUrl();
  disabledDate = (date: Date, currentValue: Date[]) => {
    return date.getTime() > Date.now();
  };
  spaces: RoomSpace[] = [];
  dataService: DataService | null = null;

  get isLogSpaceAllChecked(): boolean {
    return this.spaces.length === this.logExportSpaces.length;
  }
  set isLogSpaceAllChecked(value: boolean) {
    if (value) {
      this.logExportSpaces = this.spaces.map((v) => v.id);
    } else {
      this.logExportSpaces = [];
    }
  }
  get canExportLog(): boolean {
    return this.logExportSpaces.length > 0 || (this.logDateRange.length > 0 && !!this.logDateRange[0]);
  }
  mounted() {
    this.dataService = this.$store.state.dataService as DataService;
    this.dataService.emitGetSpaces((spaces) => (this.spaces = spaces));
    const now = new Date();
    this.defaultValue = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  }
  logExport() {
    this.isLoading = true;
    this.dataService?.emitGetLog(this.logExportSpaces, this.logDateRange).then((path) => {
      this.isLoading = false;
      const url = this.servUrl + path.path;
      console.log('download csv url', url);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.download = path.filename;
      a.href = url;
      a.click();
      a.remove();
    });
  }
}
